export default __webpack_public_path__ + "static/media/MobileasePNG.242fddcf.png";